import { ButtonGroupComponent } from './button-group/button-group.component';
import { TermsComponent } from './terms/terms.component';

export default [ButtonGroupComponent, TermsComponent];

export { ButtonGroupComponent, TermsComponent };
